import { createSlice } from '@reduxjs/toolkit';

const initialExportListState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    exportListForEdit: undefined,
    lastError: null,
    loadingProgress: false
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const exportListSlice = createSlice({
    name: 'exportList',
    initialState: initialExportListState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
                state.loadingProgress = false
            } else {
                state.actionsLoading = false;
                state.loadingProgress = false
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
                state.loadingProgress = action.payload.loadingProgress

            }
        },

        // findExportLists
        exportListsFetched: (state, action) => {
            // const { total_items, items, exportList_item_array } = action.payload;
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
            // state.exportList_item_array = exportList_item_array
        },

        // Set to default state actionLoading & error
        exportListReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
            state.loadingProgress = false;
        },

    },
});

